import { createSlice } from '@reduxjs/toolkit';

export const createSimpleReducer = <TState>(name: string, initialState: TState) => {
  const slice = createSlice({
    name,
    reducers: {},
    initialState,
  });

  return slice.reducer;
};
